import React from 'react'
import Skeleton from 'Components/Skeleton'
import { cn } from '../../lib/utils'
import { BOOKINGS_CONTENT_GUTTER } from '../../pages/MyBookings/components/bookingsLayout'

const AccountListSkeleton = ({ count = 3, className, label = 'Loading' }) => (
  <div
    className={cn('flex flex-col', className)}
    role="status"
    aria-label={label}
  >
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={index}
        className={cn('flex gap-3', BOOKINGS_CONTENT_GUTTER)}
        aria-hidden
      >
        <div className="flex min-w-0 flex-1 flex-col gap-3 border-b border-border py-6">
          <div className="flex items-center justify-between gap-3">
            <Skeleton width="42%" height="20px" borderRadius="4px" />
            <Skeleton width="72px" height="20px" borderRadius="6px" />
          </div>
          <Skeleton width="68%" height="16px" borderRadius="4px" />
          <Skeleton width="52%" height="16px" borderRadius="4px" />
        </div>
      </div>
    ))}
  </div>
)

export default AccountListSkeleton
